<template>
    <div class="item-2 mark"  :style="`position: relative;z-index :${z_index}`">
        <div class="yellowBg TitleSize">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;{{title}}</p>
            <p>总算力{{number}}P</p>
        </div>
        <div class="base-2">
            <img class="img c-img" :src="require(`@/assets/images/computility/yellowDrill.png`)" alt="">
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        title: {
            type: [String],
            default: '北京丰台算力中心'
        },
        number: {
            type: [String],
            default: '0'
        },
        z_index: {
            type: [Number,String],
            default: 0
        },
    },
    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
.yellowBg{
    position: absolute;
    background: url(~@/assets/images/computility/b-l-q.png) no-repeat;
    background-size: 100% 100%;
    font-size: 22px;
    top: -25px;
    left: 35px;
}
.base-2,.base-3{
    .c-img{
        position: absolute;
        top: -10px;
        left: 20px;
        width: 50px;
    }
}
.base-2{
    position: absolute;
    top: 60px;
    left: 140px;
    width: 150px;
    height: 150px;
    background: url(~@/assets/images/computility/yellowBase.png) no-repeat;
    background-size: 60% 60%;
}

img{
    animation: Beating 1.2s ease infinite;
}

@keyframes Beating {
    0%{
        transform: translateY(0);
    }
    50%{
        transform: translateY(5px);
    }
    100%{
        transform: translateY(0);
    }
}
</style>